/**
 * Utility function to handle potential date values being date strings
 * @param value
 * @returns
 */
export function dateStringToDate(date: string | Date): Date {
    if (typeof date === 'string') {
        const dateTimestamp = Date.parse(date);
        if (isNaN(dateTimestamp)) {
            return;
        }
        return new Date(dateTimestamp);
    }
    return date;
}
